import { AuthLayout } from '@dealstack/frontend/shared/layout/AuthLayout/AuthLayout';
import { Button } from '@dealstack/frontend/shared/components/fundament/Button/Button';
import { Text } from '@dealstack/frontend/shared/components/fundament/Text/Text';
import { BigLoaderAnimation } from '@dealstack/frontend/shared/components/loaders/BigLoaderAnimation/BigLoaderAnimation';
import { useTranslationCommonUi } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks';
import { memo, useEffect, useState } from 'react';
import styled from 'styled-components';

interface Props {
	className?: string;
}

const Counter = ({ counter }: { counter: number }): JSX.Element => {
	return <Text>{counter}</Text>;
};

const SignedRedirect = ({ className }: Props) => {
	const [counter, setCounter] = useState(5);
	const [cantClose, setCantClose] = useState(false);
	const tCommonUi = useTranslationCommonUi();
	const tryToClose = () => {
		window.close();

		setTimeout(() => {
			setCantClose(true);
		}, 10);
	};

	useEffect(() => {
		const timeout = setInterval(() => {
			setCounter((c) => {
				const val = c - 1;

				if (val === 0) {
					clearInterval(timeout);
					tryToClose();
				}

				return val;
			});
		}, 1000);

		return () => {
			clearInterval(timeout);
		};
	}, []);

	return (
		<AuthLayout isInvestorApp className={className}>
			<ContentWrapper>
				<BigLoaderAnimation />
				{cantClose ? (
					<>
						<Text variant="h2" bold center>
							{tCommonUi('signing_redirect_info_cant_close_processing.header')}
						</Text>
						<Text variant="p-lg" center>
							{tCommonUi('signing_redirect_info_cant_close_processing.body')}
						</Text>
					</>
				) : (
					<>
						<Text variant="h2" bold center>
							{tCommonUi('signing_redirect_info_processing.header')}
						</Text>
						<Text variant="p-lg" center>
							{tCommonUi('signing_redirect_info_processing.body')}
							<Counter counter={counter} />{' '}
						</Text>
						<Button size="medium" variant="primary" onClick={tryToClose}>
							<Text variant="p-lg" semiBold>
								{tCommonUi('signing_redirect_info_processing.button_content')}
							</Text>
						</Button>
					</>
				)}
			</ContentWrapper>
		</AuthLayout>
	);
};

const ContentWrapper = styled.div`
	display: flex;
	flex-direction: column;
	gap: 10px;
`;

const Memoized = memo(SignedRedirect);
const Styled = styled(Memoized)`
	${ContentWrapper} {
		${Text} {
			max-width: 40vw;
		}
	}
`;

export { Styled as SignedRedirect };
